import React from "react";
import { Link } from "react-router-dom";
import { formatDate } from "../../utils/dateFormat";

// Render "line 1\nline 2" as text with <br/> (site content stores line breaks as \n)
export function Lines({ text, breakClassName }) {
  const parts = String(text || "").split("\n");
  return parts.map((part, i) => (
    <React.Fragment key={i}>
      {i > 0 && <br className={breakClassName && i === parts.length - 1 ? breakClassName : undefined} />}
      {part}
    </React.Fragment>
  ));
}

const EXTERNAL = /^(https?:|mailto:|tel:)/i;

// Sections of the home page that have their own address: /#/services instead of /#/#services (HashRouter put the
// anchor after the route, so the address bar showed "#/#services" — owner: "ผิดรูปแบบ"). App.js renders Home for
// these paths and Home scrolls to the section.
export const HOME_SECTIONS = ["group", "services", "contact", "accounting", "news-services", "latest-news"];

// Link that understands site-content targets:
//   "/newspaper"   → router link
//   "/#services"   → /services: home page scrolled to the section (also "/services" directly)
//   "/page#id"     → that page + scroll to #id
//   "https://…"    → normal <a>, new tab
export function SiteLink({ to = "/", children, ...rest }) {
  const target = String(to || "/");
  if (EXTERNAL.test(target)) {
    const newTab = /^https?:/i.test(target);
    return (
      <a href={target} {...(newTab ? { target: "_blank", rel: "noreferrer" } : {})} {...rest}>
        {children}
      </a>
    );
  }
  const hashIndex = target.indexOf("#");
  if (hashIndex !== -1) {
    const pathname = target.slice(0, hashIndex) || "/";
    const section = target.slice(hashIndex + 1);
    if (pathname === "/" && HOME_SECTIONS.includes(section)) {
      return (
        <Link to={`/${section}`} {...rest}>
          {children}
        </Link>
      );
    }
    return (
      <Link to={{ pathname, hash: target.slice(hashIndex) }} {...rest}>
        {children}
      </Link>
    );
  }
  return (
    <Link to={target} {...rest}>
      {children}
    </Link>
  );
}

// Site date format (owner rule): dd-mm-yyyy, Buddhist-era year, e.g. "26-10-2569"
export function thaiDate(value) {
  return formatDate(value);
}
